import { ErrorBase } from '@/errors/ErrorBase';

export class SSONotSettingError extends ErrorBase {
    static get defaultMessage(): string {
        return 'クラウドIDがちがうかシングルサインオンのせっ定がされていません。';
    }

    static get errorName(): string {
        return 'SSONotSettingError';
    }
}
